import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import doraMetricsPlugin from '@c2l2c/backstage-plugin-dora-metrics/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import sentryPlugin from '@backstage-community/plugin-sentry/alpha';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';

import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';

const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Sign in using Microsoft',
  apiRef: microsoftAuthApiRef,
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      // Guest sign-in is offered only in local dev; production is Microsoft-only.
      process.env.NODE_ENV !== 'production' ? (
        <SignInPage {...props} auto providers={['guest', microsoftProvider]} />
      ) : (
        <SignInPage {...props} provider={microsoftProvider} />
      ),
  },
});

// Render ```mermaid fenced blocks (class diagrams etc.) in the TechDocs reader.
const techDocsMermaidAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: {
    name: 'Mermaid',
    location: TechDocsAddonLocations.Content,
    component: Mermaid,
  },
});

const techDocsMermaidModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techDocsMermaidAddon],
});

export default createApp({
  features: [
    catalogPlugin,
    doraMetricsPlugin,
    sentryPlugin,
    grafanaPlugin,
    navModule,
    themeModule,
    techDocsMermaidModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
